import { AlertMessage } from 'components/notification/AlertMessage';
import { func_validation } from 'functions';
import React, { useEffect, useState } from 'react';

export function useAlertMessage(props) {
    const {
        postToSQLAccount_errorMsg,
        sendEmail_errorMsg,
        deleteInvoice_errorMsg,
        postCreditNote_errorMsg
    } = props;

    const [alertMsg, setAlertMsg] = useState([]);
    const [isAlertMsgVisible, setIsAlertMsgVisible] = useState(false);

    // Error Messages
    function updateErrorMsg(msg) {
        if (func_validation.isStringTrimNotEmpty(msg)) {
            let alertMsg_new = func_validation.cloneArray(alertMsg);
            let index = func_validation.getArrayLength(alertMsg_new, 0);
    
            alertMsg_new.push(<p key={index}>{msg}</p>);
            setAlertMsg(alertMsg_new);
            setIsAlertMsgVisible(true);
        }
    } 
    useEffect(() => {
        updateErrorMsg(postToSQLAccount_errorMsg);
    }, [postToSQLAccount_errorMsg]);
    useEffect(() => {
        updateErrorMsg(sendEmail_errorMsg);
    }, [sendEmail_errorMsg]);
    useEffect(() => {
        updateErrorMsg(deleteInvoice_errorMsg);
    }, [deleteInvoice_errorMsg]);
    useEffect(() => {
        updateErrorMsg(postCreditNote_errorMsg);
    }, [postCreditNote_errorMsg]);

    let alertMsgDisplay = (
        <div className={"pb-3"}>
            <AlertMessage
                message={alertMsg}
                isVisible={isAlertMsgVisible}
                toggleVisibility={() => { setIsAlertMsgVisible(!isAlertMsgVisible); }}
            />
        </div>
    );
    
    return {
        setAlertMsg,
        alertMsgDisplay
    };
}